import React from "react";
import { useTranslation } from "react-i18next";
import { IntercomConversationApi } from "../../../../../../../../services/Api/Admin/adminTypes";
import OrganizationIntercomSingleConversation from "./OrganizationIntercomSingleConversation";

interface Props {
	conversations: IntercomConversationApi[];
}

const OrganizationIntercomConversations = ({ conversations }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<div>
			<div className="d-flex intercom-conversations-header">
				{/*<h5>{t("components.organization.components.tab.support.intercom_conversations.header.title")}</h5>*/}
				<h5>{t("modules.organization.field.intercom_conversations.title")}</h5>
			</div>
			<div className="flex-column">
				{conversations.map((conversation) => {
					return <OrganizationIntercomSingleConversation key={conversation.id} conversation={conversation} />;
				})}
			</div>
		</div>
	);
};

export default OrganizationIntercomConversations;
